import React from 'react';

import { TableContainer, TableHeader } from '@occc/ui-design-system';
import { useGetProductCategories } from '@occc-app/dataAccessLayer/productCategory/queries';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { ProductCategoriesTable } from './ProductCategoriesTable';

export const ProductCategoriesTableContainer: React.FC = () => {
  const [paginationInfo, onPageChange] = usePaginationParams();

  const { loading, error, data, paginationProps } = useGetProductCategories({
    paginationInfo,
    onPageChange,
  });

  const isUserPermittedToEditProductCategory = useIsUserPermittedTo(Feature.PRODUCT_CATEGORY_EDIT);

  return (
    <TableContainer>
      <TableHeader title='Product Preferences' />
      <ProductCategoriesTable
        productCategories={data}
        loading={loading}
        error={error}
        paginationProps={paginationProps}
        isUserPermittedToEditProductCategory={isUserPermittedToEditProductCategory}
      />
    </TableContainer>
  );
};
